import { call, put, takeEvery } from 'redux-saga/effects';
import { DEALER_DATA_REVISIONS_REQUEST } from './actionTypes';
import {
  dealerDataRevisionsSuccess,
  dealerDataRevisionsFailure,
} from './actions';
import DealerDataRevisionService from '../../services/DealerDataRevisionService';

export function* getDealerRevisions(action) {
  try {
    const dealers = yield call(
      DealerDataRevisionService.getRevisions,
      action.payload.dealerId,
      action.payload.options,
    );
    yield put(dealerDataRevisionsSuccess(dealers));
  } catch (error) {
    yield put(dealerDataRevisionsFailure(error));
  }
}

export function* dealerDataRevisionsSaga() {
  yield takeEvery(DEALER_DATA_REVISIONS_REQUEST, getDealerRevisions);
}
